





import { Route } from 'vue-router'
import { mapGetters, mapActions } from 'vuex'
import { DEALER_SITE_NS } from '~/store/modules/shared/dealers/site/state'
import {
  defineNuxtComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  components: {
    ClassifiedPage: defineVue3AsyncComponent(() =>
      import('~/pages/car/classifieds/view/view.vue')
    )
  },
  async asyncData({ store, route }) {
    await store.dispatch(`${DEALER_SITE_NS}/loadClassified`, route)
  },
  computed: {
    ...mapGetters(DEALER_SITE_NS, [
      'activePage',
      'componentShouldRenderPage',
      'shouldAnimatePageTransition',
      'loading'
    ])
  },
  watch: {
    async $route(to: Route, from: Route) {
      await this.loadPageByPath({ to, from })
    }
  },
  methods: {
    ...mapActions(DEALER_SITE_NS, ['loadPageByPath'])
  }
})
